
import Vue, { PropType } from 'vue';
import { sortBy } from 'sort-by-typescript';
import {
  ColumnItem,
  FilterItem,
  MonitoringInfo,
  SelectedFilter,
  TerritoryInfo,
} from '@/config/types';
import Dropdown from '@/components/Dropdown/index.vue';
import MenuFilter from '@/components/MenuFilter/index.vue';
import ModalDefault from '@/components/ModalFrigo/index.vue';
import Card from '@/components/Card/index.vue';
import Tag from '@/components/Tag/index.vue';
import createTerritoryAccessRequest from '@/services/territory-access/create';
import { getUserGroup } from '@/utils';
import { formatAgentQuantity, formatStatusAct } from '@/utils/format-agent-quantity';
import Button from '@/components/Button/index.vue';
import {
  AccessDetails, HeadDetails, Label, Requested,
} from '@/components/ResultSearch/styles';
import {
  ContentTypes,
  WrapperTableHeader,
  WrapperTableMain,
  DivFlex,
  TerritoryCard,
  WrapperTable,
}
  from './styles';

export default Vue.extend({
  name: 'Table',
  components: {
    Dropdown,
    MenuFilter,
    Tag,
    WrapperTableHeader,
    WrapperTableMain,
    DivFlex,
    TerritoryCard,
    WrapperTable,
    AccessDetails,
    HeadDetails,
    Label,
    Requested,
    ModalDefault,
    Card,
    Button,
  },
  props: {
    pending: {
      type: Boolean,
      default: false,
    },
    list:
      (Array as PropType<Array<TerritoryInfo>>)
      || (Array as PropType<Array<MonitoringInfo>>),
    contentType: {
      type: String,
      default: 'territory',
      validator(value: typeof ContentTypes[number]) {
        return ContentTypes.indexOf(value) !== -1;
      },
    },
    userType: {
      type: String,
    },
    isAccess: {
      type: Boolean,
      default: false,
    },
    isAccessPending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headerColumns: [{}],
      modalAddAgent: false,
      dataInfo: [],
      icon: this.pending ? 'options' : 'chevron-left',
      iconTitle: {
        'chevron-left': 'Detalhes da fazenda',
        options: 'Gerenciar solicitação',
      },
      menuSolicitation: [
        { component: 'Resend', title: 'Reenviar Solicitação' },
        { component: 'Close', title: 'Cancelar Solicitação' },
      ],
      isModalActivated: false,
      buttonDisable: false,
      modalButtons: [
        {
          click: 'closeModal',
          title: 'Ok, voltar',
          type: 'primary',
        },
      ],
      filteredList: [] as Array<TerritoryInfo> | Array<MonitoringInfo>,
      fullList: [] as Array<TerritoryInfo> | Array<MonitoringInfo>,
      selectedFilters: [{}] as Array<SelectedFilter>,
      territoriesImg: [] as Array<string>,
    };
  },
  created() {
    let columns = [{}] as Array<ColumnItem>;

    if (this.contentType === 'territory') {
      columns = [
        { title: this.$t('owner') as string, property: 'agent' },
        { title: this.$t('farm_name') as string, property: 'name' },
        { title: this.$t('car_territory') as string, property: 'car' },
        { title: this.$t('city') as string, property: 'city' },
        { title: this.$t('status_act') as string, property: 'actCurrent' },
      ];
    } else {
      columns = [
        { title: 'Tipo', property: 'type', dontShowFilter: true },
        { title: 'Início do prazo', property: 'dtStart' },
        { title: 'Fim do prazo', property: 'dtEnd' },
        { title: 'Status', property: 'status', hasTag: true },
        { title: 'Resultado', property: 'result', hasTag: true },
      ];
    }

    this.headerColumns = columns.map((column: ColumnItem) => ({
      ...column,
      id: column.property === 'agent' ? 'agents' : column.property,
      visible: false,
      ascOrder: false,
    }));

    columns.forEach((c) => { // aqui ele adiciona na selectedFilters o obejto de property agents
      this.selectedFilters.push({
        property: c.property === 'agent' ? 'agents' : c.property,
        selected: [],
      });
    });

    if (this.list) {
      this.fullList = this.list.map((item: TerritoryInfo | MonitoringInfo) => ({
        ...item,
        visible: false,
        agent: formatAgentQuantity(item.agents || []),
        // @ts-ignore
        actCurrent: formatStatusAct(item.actCurrent),
        // @ts-ignore
        car: item.documents[0].title,
      })) as Array<TerritoryInfo> | Array<MonitoringInfo>;

      this.filteredList = this.fullList;
    }
  },
  computed: {
    options() {
      return (key: string) => this.getOptions(key as keyof (TerritoryInfo | MonitoringInfo));
    },
  },
  methods: {
    clear(property: keyof (TerritoryInfo | MonitoringInfo)) {
      this.filteredList = this.fullList;
      this.selectedFilters.forEach((f) => {
        if (f.property !== property && f.selected && f.selected.length) {
          this.filter();
        }
      });
    },
    filter() {
      const fullList = this.fullList as Array<TerritoryInfo | MonitoringInfo>;
      let list = fullList;

      this.selectedFilters.forEach((selectedFilter) => {
        if (selectedFilter.selected && selectedFilter.selected.length) {
          const { selected, property } = selectedFilter;

          if (property === 'agents') {
            list = list.filter(
              (t: TerritoryInfo | MonitoringInfo) => t.agents
                && t.agents.filter((a) => selected.indexOf(a.name) !== -1).length,
            );
          } else {
            list = list.filter(
              (territory: TerritoryInfo | MonitoringInfo) => selected.indexOf(
                  territory[
                    property as keyof (TerritoryInfo | MonitoringInfo)
                  ] as string | number,
              ) !== -1,
            );
          }
        }
      });

      this.filteredList = list as [];
    },
    goToDetails(id: number, name: string, item: any) {
      if (this.isAccess) {
        this.$router.push(`/${getUserGroup()}/territorio/${id}/${name}`);
      }
      if (this.isAccessPending) {
        this.modalAddAgent = !this.modalAddAgent;
        this.dataInfo = item;
      }
    },
    getOptions(property: keyof (TerritoryInfo | MonitoringInfo)) {
      let distinctValues = [] as Array<string | number | boolean | undefined>;

      if (property === 'agents') {
        const values = [] as Array<string>;
        (this.fullList as Array<TerritoryInfo>).forEach((t) => {
          values.push(...t.agents.map((a) => a.name));
        });
        distinctValues = [...new Set(values)];
      } else {
        distinctValues = [
          ...new Set(
            (this.fullList as Array<TerritoryInfo | MonitoringInfo>).map(
              (t: TerritoryInfo | MonitoringInfo) => t[property],
            ),
          ),
        ];
      }

      const selectedFilter = this.selectedFilters.find(
        (s) => s.property === property,
      );
      const options = (distinctValues.map((item, i) => ({
        id: i,
        value: item,
        checked: selectedFilter
          ? selectedFilter.selected.indexOf(item) !== -1
          : false,
      })) as unknown) as Array<FilterItem>;

      return options;
    },
    openMenu(options: boolean, id: number) {
      const list = options
        ? this.fullList
        : (this.headerColumns as Array<ColumnItem>);

      list.forEach((l: ColumnItem | TerritoryInfo | MonitoringInfo) => {
        const item = l;
        if (item.id === id) item.visible = !item.visible;
        else item.visible = false;
      });
    },
    async makeRequest(territoryId: string) {
      const userLogged = sessionStorage.getItem('userLogged') as string;
      const parse = JSON.parse(userLogged);
      const { idUser, company } = parse;

      const responseCreate = {
        frigId: idUser.toString(),
        territoryId,
        tokenKey: company.stKey.toString(),
      };
      await createTerritoryAccessRequest(responseCreate);
      this.isModalActivated = true;
    },
    orderBy(property: keyof (TerritoryInfo | MonitoringInfo)) {
      const item = (this.headerColumns as Array<ColumnItem>).find(
        (column: ColumnItem) => column.property === property,
      ) as ColumnItem;

      if (item.ascOrder) this.filteredList.sort(sortBy(property));
      else this.filteredList.sort(sortBy(`-${property}`));

      item.ascOrder = !item.ascOrder;
    },
  },
});
